import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import "bootstrap/dist/css/bootstrap.min.css";
import "./SidebarStyle2.scss";
import { HiMenuAlt3, HiX, HiHome } from "react-icons/hi";
import { MdAdminPanelSettings } from "react-icons/md";
import Logo from "../../../assets/images/home/new-logo.png";

const SideBar = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [allObras, setAllObras] = useState({});

  useEffect(() => {
    const fetchObras = async () => {
      try {
        console.log("Buscando obras para o sidebar...");
        const response = await fetch("/api/obras");
        if (!response.ok) throw new Error("Falha ao buscar obras");
        const data = await response.json();

        const structured = {};
        data.forEach(obra => {
          const estado = obra.estado || "Geral";
          const cidade = obra.cidade || "Outros";

          if (!structured[estado]) structured[estado] = {};
          if (!structured[estado][cidade]) structured[estado][cidade] = [];
          structured[estado][cidade].push({
            nome: obra.nome,
            url: obra.url
          });
        });


        const ordered = {};
        Object.keys(structured).sort().forEach(estado => {
          ordered[estado] = {};
          Object.keys(structured[estado]).sort().forEach(cidade => {
            ordered[estado][cidade] = structured[estado][cidade].sort((a, b) => a.nome.localeCompare(b.nome));
          });
        });

        setAllObras(ordered);
      } catch (error) {
        console.error("Erro ao carregar obras no sidebar:", error);
      }
    };
    fetchObras();
  }, []);

  const Exit = () => {
    window.location.replace("/");
    localStorage.removeItem("isAuth");
  };

  const normalizeString = (str) => {
    return str
      ? str
          .toLowerCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
      : "";
  };

  const renderFullList = () => {
    return Object.entries(allObras).map(([estado, cidades]) => (
      <NavDropdown
        key={estado}
        id="nav-dropdown"
        title={estado}
        menuVariant="dark"
        className="nav-item"
      >
        {Object.entries(cidades).map(([cidade, obras]) => (
          <NavDropdown
            key={cidade}
            id="nav-dropdown-submenu"
            title={cidade}
            menuVariant="dark"
            className="dropdown"
          >
            {obras.map((obra) => (
              <NavDropdown.Item
                key={obra.url}
                as={Link}
                to={`/obra/${obra.url}`}
              >
                {obra.nome}
              </NavDropdown.Item>
            ))}
          </NavDropdown>
        ))}
      </NavDropdown>
    ));
  };

  const renderFilteredList = () => {
    const results = [];
    const normalizedSearchTerm = normalizeString(searchTerm);

    Object.values(allObras).forEach((cidades) => {
      Object.values(cidades).forEach((obras) => {
        obras.forEach((obra) => {
          if (normalizeString(obra.nome).includes(normalizedSearchTerm)) {
            results.push(
              <NavDropdown.Item
                key={obra.url}
                as={Link}
                to={`/obra/${obra.url}`}
              >
                {obra.nome}
              </NavDropdown.Item>
            );
          }
        });
      });
    });

    return results.length > 0 ? (
      results
    ) : (
      <NavDropdown.Item disabled>Nenhuma obra encontrada.</NavDropdown.Item>
    );
  };

  return (
    <>
      <div id="wrapper">
        <Navbar variant="dark" expand="lg">
          <div className="menu-mobile">
            <Navbar.Toggle aria-controls="navbarScroll">
              <HiMenuAlt3 />
            </Navbar.Toggle>
          </div>

          <Navbar.Collapse className="navigation">
            <div className="close">
              <Navbar.Toggle aria-controls="navbarScroll">
                <HiX />
              </Navbar.Toggle>
            </div>
            <Container fluid>
              <img className="logo" src={Logo} alt="Logo MRV" />

              <div className="sidebar-header-actions">
                <Navbar.Brand>
                  <Link to="/home">
                    <HiHome />
                    <span>Início</span>
                  </Link>
                </Navbar.Brand>

                <Navbar.Brand>
                  <Link to="/admin">
                    <MdAdminPanelSettings />
                    <span>Admin</span>
                  </Link>
                </Navbar.Brand>

                <button
                  onClick={Exit}
                  type="button"
                  className="btn-exit-top"
                  title="Sair"
                >
                  Sair
                </button>
              </div>

              <div className="search-box">
                <input
                  type="text"
                  placeholder="Buscar obra..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>

              <Navbar id="navbar-dark-submenu">
                <Nav className="navbar-nav">
                  {searchTerm === "" ? (
                    renderFullList()
                  ) : (
                    <div className="search-results">{renderFilteredList()}</div>
                  )}
                </Nav>
              </Navbar>
            </Container>
          </Navbar.Collapse>
        </Navbar>
      </div>
    </>
  );
};
export default SideBar;
